import { render } from "./Front.vue?vue&type=template&id=0d7611b9&scoped=true"
import script from "./Front.vue?vue&type=script&lang=js"
export * from "./Front.vue?vue&type=script&lang=js"

import "./Front.vue?vue&type=style&index=0&id=0d7611b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7611b9"]])

export default __exports__